import React, { Component } from 'react'
import request from '../../lib/requester'
import _ from 'lodash'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import moment from "moment";
// import JSBarcode from "jsbarcode"
// import canvas from "canvas"

class submitAWB extends Component {
    constructor(props) {
        super(props);
        this.state = {
            awb_no: '',
            success: '',
            dataTable: [],
            baseTable: [],
            loading: false,
            user: JSON.parse(window.localStorage.getItem('is_user')) || {},
            selectedClaim: []
        }
    }

    componentDidMount = () => {}

    getList = () => {
        let url = '/api/traces/v1/document/list-receive-principal'
        let param = {
            org_id: this.state.user.org_id || '',
            awb_no: this.state.awb_no
        }
        this.setState({ loading: true })
        request.postTraces(url, param, {
            success: function (response) {
                let { data } = response.data
                this.setState({ dataTable: data, baseTable: data, loading: false })
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    handleChangeAWB = (e) => {
        let value = e.target.value
        value = value.replace(/\s+/g, '')
        this.setState({ awb_no: value })
    }

    handleFind = () => {
        this.getList()
    }

    handleSubmitAWB = () => {
        let { selectedClaim, awb_no } = this.state
        if (awb_no.length === 0) {
            alert('AWB Number is empty')
            return false
        }
        if (selectedClaim.length === 0) {
            alert('Please select cover letter no')
            return false
        }

        let url = "/api/traces/v1/document/receive-principal"
        let param = {
            letter_no: selectedClaim,
            awb_no: awb_no
        }

        this.setState({ loading: true })
        request.postTraces(url, param, {
            success: function (response) {
                let total = this.state.selectedClaim.length
                this.setState({ loading: false, success: 'AWB Number with ' + total + ' cover letter has been confirmed successfully' })
                // this.exportPDF()
                window.setTimeout(() => {
                    window.location.reload()
                }, 3000)
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    handleRefuseAWB = () => {
        let { selectedClaim, awb_no, dataTable } = this.state
        if (awb_no.length === 0) {
            alert('AWB Number is empty')
            return false
        }
        if (selectedClaim.length === 0) {
            alert('Please select claim')
            return false
        }

        var dif = _.differenceWith(dataTable, selectedClaim, _.isEqual);
        let url = "/api/traces/v1/document/refuse-awb"
        let param = {
            claim_confirm: selectedClaim || []
            // ,
            // claim_reset: dif || [],
            // awb_no: awb_no
        }

        this.setState({ loading: true })
        request.postTraces(url, param, {
            success: function (response) {
                this.setState({ loading: false, success: 'AWB Number has been refused' })
                // this.exportPDF()
                window.setTimeout(() => {
                    window.location.reload()
                }, 2000)
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    handleFind = () => {
        if (this.state.awb_no === '') {
            alert('AWB Number is empty')
            return false
        }
        this.getList()
    }

    handleCheckClaim = (e) => {
        let value = e.target.value
        let { selectedClaim, dataTable } = this.state
        let isChecked = e.target.checked
        if (isChecked) {
            console.log('Checked', value)
            let claimDetail = _.find(dataTable, function (o) {
                return o.principal_letter_no === value
            })
            console.log('claimDetail', claimDetail)
            if (claimDetail) {
                selectedClaim.push(claimDetail)
            }
        } else {
            let findIndex = _.findIndex(selectedClaim, function (o) {
                return parseInt(o.claim_id) === parseInt(value)
            })
            selectedClaim.splice(findIndex, 1)
        }
        this.setState(selectedClaim)
        let app = this

        window.setTimeout(() => {
            console.log(app.state.selectedClaim)
        }, 200)
    }

    showSuccess = () => {
        if (this.state.success.length > 0) {
            return (
                <div className="alert alert-success" role="alert">
                    <i className="fas fa-check"></i> {this.state.success}
                </div>
            )
        }
    }

    handleCheckAll = (e) => {
        let dataTable = this.state.dataTable
        let selectedClaimed = []
        dataTable.forEach((item, index) => {
            selectedClaimed.push(item)
        })
        let isChecked = e.target.checked
        if (isChecked) {
            this.setState({ selectedClaim: selectedClaimed })
        } else {
            this.setState({ selectedClaim: [] })
        }
        let app = this
        window.setTimeout(() => {
            console.log(app.state.selectedClaim)
        }, 200)
    }

    renderTable = () => {
        let app = this
        const data = {
            columns: [
                {
                    Header: () => (
                        <span>
                            <input type="checkbox" className="form-control-sm" value="" onClick={app.handleCheckAll.bind(app)} />
                        </span>
                    ),
                    sortable: false,
                    resizable: false,
                    accessor: 'principal_letter_no',
                    width: 50,
                    className: 'text-center',
                    Cell: function (row) {
                        let findIndex = _.findIndex(app.state.selectedClaim, function (o) {
                            return o.principal_letter_no === row.value
                        })
                        let checked = findIndex >= 0 ? true : false
                        return (
                            <input type="checkbox" name="awb_claim" value={row.value} onChange={app.handleCheckClaim.bind(app) } checked={checked} />
                        )
                    }
                },
                {
                    Header: 'COVER LETTER NO',
                    accessor: 'principal_letter_no',
                    filterable: true,
                },
                {
                    Header: 'NUMBER OF CLAIM',
                    accessor: 'total_claim',
                    filterable: true
                },
                {
                    Header: 'TOTAL CLAIM',
                    accessor: 'total_amount',
                    className: 'text-right',
                    filterable: true,
                    Cell: function(row) {
                        return (
                        <span>{ app.thousandSeparator(parseInt(row.value)) }</span>
                        )
                    }
                }
            ],
            rows: this.state.dataTable
        }
        return (<ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
            defaultFilterMethod={((filter, row, column) => {
                let columnes = row[filter.id]
                return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
            })}
        />)
    }

    thousandSeparator = (value) => {
        value = value.toString()
        value = value.replace(/,/g, '').replace(/(?!^-)[^0-9.]/g, '');
        var parts = value.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

    goDetail = (claim_id) => {
        this.props.history.push('/admin/awb/view/' + claim_id)
    }

    handleClear = () => {
        this.setState({ selectedClaim: [], awb_no: ''})
    }
    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12 col-sx-12">
                                <div className="card card-info">
                                    <div className="card-header">List</div>
                                    <div className="card-body">
                                        {this.showSuccess()}
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="AWB Number" value={this.state.awb_no} onChange={this.handleChangeAWB.bind(this)} />
                                            </div>
                                            <div className="col-lg-4">
                                                <button className="btn btn-info" onClick={this.handleFind.bind(this)}>Find</button>&nbsp;
                                                <button className="btn btn-success" onClick={this.handleSubmitAWB.bind(this)}>Confirm</button>&nbsp;
                                                <button className="btn btn-danger" onClick={this.handleRefuseAWB.bind(this)}>Refuse</button>&nbsp;
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-lg-12">
                                                {this.renderTable()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Loader fullPage loading={this.state.loading} />
                </section>
            </div>
        )
    }
}

export default submitAWB